import React from 'react';
import { Row} from 'react-bootstrap';
import Landing from 'components/pages/landing/Landing';
const Dashboard = () => {
  return (
    <>

      
        <Landing/>
      
    </>
  );
};

export default Dashboard;
